import React from 'react';
import { TimePicker as AntTimePicker } from 'antd';

const format = 'HH:mm';

const TimePicker = ({className,id,value, disabled,onChangeTime}) => {

    const onChange = (time) => {
        onChangeTime(time);
    };

    return <AntTimePicker id={id} className={className} needConfirm={false} minuteStep={15} value={value} onChange={onChange} format={format} disabled={disabled}/>;
}

export default TimePicker;